import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ShieldCheck, ArrowLeft } from "lucide-react";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (password.length < 8) { toast.error("Wachtwoord minimaal 8 tekens"); return; }
    if (password !== confirm) { toast.error("Wachtwoorden komen niet overeen"); return; }
    setBusy(true);
    try {
      await api.post("/backend-auth/reset-password", { token, password });
      setDone(true);
      toast.success("Wachtwoord opnieuw ingesteld");
    } catch (e) { toast.error(e?.response?.data?.detail || "Herstellen mislukt"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-md bg-white border rounded-2xl shadow-sm p-8 space-y-5 animate-fade-in-up">
        <button onClick={() => navigate("/inloggen")} className="flex items-center gap-2 text-sm text-slate-500"><ArrowLeft className="h-4 w-4" /> Naar inloggen</button>
        <div className="flex items-center gap-3">
          <div className="h-11 w-11 rounded-xl bg-blue-900 flex items-center justify-center"><ShieldCheck className="h-6 w-6 text-white" /></div>
          <div><h1 className="font-heading text-xl font-bold text-slate-900">Nieuw wachtwoord instellen</h1><p className="text-xs text-slate-500">Beheeraccount</p></div>
        </div>
        {!token ? (
          <p className="text-sm text-red-600" data-testid="reset-no-token">Ongeldige of ontbrekende herstellink.</p>
        ) : done ? (
          <div className="space-y-3">
            <p className="text-sm text-emerald-700" data-testid="reset-success">Uw wachtwoord is opnieuw ingesteld. U kunt nu inloggen.</p>
            <Button className="w-full bg-blue-900 hover:bg-blue-800" onClick={() => navigate("/inloggen")} data-testid="reset-to-login">Naar inloggen</Button>
          </div>
        ) : (
          <div className="space-y-3">
            <div><Label>Nieuw wachtwoord</Label><Input type="password" data-testid="reset-pw" value={password} onChange={(e) => setPassword(e.target.value)} /></div>
            <div><Label>Herhaal wachtwoord</Label><Input type="password" data-testid="reset-pw-confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} /></div>
            <Button className="w-full bg-blue-900 hover:bg-blue-800" onClick={submit} disabled={busy || password.length < 8} data-testid="reset-submit">Wachtwoord opslaan</Button>
          </div>
        )}
      </div>
    </div>
  );
}
